import { Link } from "react-router-dom";
import { ClipboardCheck, ShieldCheck, Car, Sparkles, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { services } from "@/lib/siteConfig";
import { useCmsDocument } from "@/cms/CmsContentProvider";

const iconMap = { ClipboardCheck, ShieldCheck, Car, Sparkles };

// Premium, media-led service cards (image-topped) inspired by the reference
// site's service presentation. Equal-height, overflow-safe, calm hover lift.
export const ServiceShowcase = () => {
  const { locale } = useCmsDocument();
  return (
    <div
      className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
      data-testid="services-preview-grid"
    >
      {services.map((s, i) => {
        const Icon = iconMap[s.icon] || Sparkles;
        // Versicherung uses the Insurance Green accent; all other cards keep
        // the AZ Red accent for icon + hover border.
        const isGreen = s.id === "versicherung";
        const hoverBorder = isGreen ? "hover:border-[#156F39]/30" : "hover:border-[#7A1516]/30";
        const iconColor = isGreen ? "text-[#156F39]" : "text-[#7A1516]";
        return (
          <Reveal key={s.id} delay={i * 0.12} className="h-full">
            <Link
              to={`/${s.id}`}
              data-testid={`services-preview-card-${s.id}`}
              className={`group flex h-full flex-col overflow-hidden rounded-2xl border border-[#D5DEE8] bg-white shadow-[var(--shadow-soft)] transition-all duration-[350ms] ease-out hover:-translate-y-1.5 ${hoverBorder} hover:shadow-[var(--shadow-card)]`}
            >
              <div className="az-media-zoom az-service-frame relative aspect-[4/3] w-full overflow-hidden rounded-t-2xl">
                <img
                  src={s.image}
                  alt={s.alt}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
                <div
                  className="pointer-events-none absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(25, 61, 109,0.05) 0%, rgba(25, 61, 109,0.35) 100%)",
                  }}
                />
                <span className={`absolute left-4 top-4 flex h-12 w-12 items-center justify-center rounded-xl bg-white/95 ${iconColor} shadow-[0_8px_20px_rgba(0,0,0,0.18)]`}>
                  <Icon size={22} />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-2xl font-semibold leading-snug text-[#193D6D] [overflow-wrap:anywhere]">
                  {s.title}
                </h3>
                <p className="mt-2 flex-1 leading-relaxed text-[#586576] hyphens-auto [overflow-wrap:anywhere]">
                  {s.short}
                </p>
                <span className={`mt-5 inline-flex items-center gap-1.5 text-sm font-semibold uppercase tracking-[0.12em] ${iconColor}`}>
                  {locale === "ar" ? "معرفة المزيد" : "Mehr erfahren"}
                  <ArrowRight
                    size={16}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </span>
              </div>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
};
